import { Badge } from '@mantine/core';
import FormattedRecordTimestamp from '../../../utils/FormattedRecordTimestamp';
import { Persona } from '../../personas/types';

export const usePersonasTableColumns = () => {
    return [
        { accessor: 'givenName', title: 'Given Name' },
        { accessor: 'familyName', title: 'Family Name' },
        { accessor: 'email', title: 'Email' },
        { accessor: 'status', title: 'Status', render: (row: Persona) => (
            <Badge color={row.status === 'ENABLED' ? 'green' : 'red'}>{row.status}</Badge>
        )},
        { accessor: 'createdByUsername', title: 'Owner' },
        { accessor: 'created', title: 'Created', render: (row: Persona) => (
            <FormattedRecordTimestamp record={row} propertyName="created" />
        )}
    ];
};
